import { ChangeDetectionStrategy, Component, OnDestroy, signal, Signal } from '@angular/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationSkipped, NavigationStart, Router, RouterEvent } from '@angular/router';
import { Hub } from '@aws-amplify/core';
import { Subscription } from 'rxjs';
import { AuthedUser, AuthService } from './auth.service';
import { LoggerService } from '@sko/ng-logging';
import { StopListenerCallback } from 'node_modules/@aws-amplify/core/dist/esm/Hub/types';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.sass',
    standalone: false
})
export class AppComponent implements OnDestroy {
  
  private hubListeners: Array<StopListenerCallback> = [];

  private routeLoadingSignal = signal<boolean>(false);

  routeLoading = this.routeLoadingSignal.asReadonly();

  private sub: Subscription;

  user: Signal<AuthedUser | undefined>;

  constructor(
    private auth: AuthService,
    private logger: LoggerService,
    private router: Router,
  ) {

    this.hubListeners.push(Hub.listen('core', (capsule) => {

      this.logger.info({ capsule }, 'AppComponent core')

      this.logger.info({ capsule }, 'core');

    }));

    this.sub = this.router.events.subscribe((event) => {

      this.onRouterEvent(event);

    });

    this.user = this.auth.user;

  }

  ngOnDestroy(): void {
    
    this.hubListeners.forEach((cancel) => cancel());

    this.sub.unsubscribe();

  }

  private onRouterEvent(event: Event | RouterEvent) {

    switch (true) {

      case event instanceof NavigationCancel:
      case event instanceof NavigationEnd:
      case event instanceof NavigationError:
      case event instanceof NavigationSkipped:

        this.routeLoadingSignal.set(false);

        break;

      case event instanceof NavigationStart:

        this.routeLoadingSignal.set(true);

        break;

    }

  }
  
}
